import { gql } from 'apollo-boost';

export const verifyTokenMutation = gql`
  mutation VerifyToken($token: String!) {
    verifyToken(token: $token) {
      ok
      errors {
        field
        messages
        code
      }
      user {
        id
        types
        isAdmin
        isSuperManager
        permissions
        fullName
        club {
          id
        }
      }
      club {
        id
        shortName
      }
    }
  }
`;

export const authTokenMutation = gql`
  mutation authToken($email: String!, $password: String!) {
    authToken(email: $email, password: $password) {
      ok
      token
      user {
        id
        types
        isAdmin
        isSuperManager
        permissions
        fullName
        club {
          id
        }
      }
      club {
        id
        shortName
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const registerUserMutation = gql`
  mutation registerUser($inputData: RegisterInput!) {
    registerUser(inputData: $inputData) {
      ok
      token
      user {
        id
        firstName
        fullName
        club {
          id
        }
      }
      club {
        id
        shortName
      }
      errors {
        field
        messages
      }
    }
  }
`;
